import { defineComponent, computed } from 'vue';

var script = defineComponent({
    name: 'Skeleton',
    props: {
        borderRadius: {
            type: String,
            default: null,
        },
        circle: Boolean,
        height: {
            type: String,
            default: null,
        },
        inlineBlock: Boolean,
        maxWidth: {
            type: String,
            default: null,
        },
        noDefaults: Boolean,
        noRounding: Boolean,
        slotLoading: Boolean,
        verticalMargin: {
            type: String,
            default: null,
        },
        width: {
            type: String,
            default: null,
        },
    },
    setup(props, { slots }) {
        const classNames = computed(() => {
            const names = [];
            if (props.circle)
                names.push('Skeleton--circle');
            if (props.inlineBlock)
                names.push('Skeleton--inline-block');
            if (props.noRounding)
                names.push('Skeleton--no-rounding');
            if (props.noDefaults || slots.default)
                names.push('Skeleton--no-defaults');
            if (slots.default) {
                names.push('Skeleton--with-slot');
                if (props.slotLoading)
                    names.push('Skeleton--slot-loading');
                else
                    names.push('Skeleton--slot-loading-completed');
            }
            return names;
        });
        const style = computed(() => {
            const styleObj = {};
            if (props.height)
                styleObj.height = props.height;
            if (props.width)
                styleObj.width = props.width;
            if (props.maxWidth) {
                styleObj.width = '100%';
                styleObj.maxWidth = props.maxWidth;
            }
            if (props.verticalMargin) {
                styleObj.marginTop = props.verticalMargin;
                styleObj.marginBottom = props.verticalMargin;
            }
            if (props.borderRadius) {
                styleObj.borderRadius = props.borderRadius;
            }
            return styleObj;
        });
        return {
            classNames,
            style,
        };
    },
});

export { script as default };
